import { render, staticRenderFns } from "./sitePermitsHomePageCard.vue?vue&type=template&id=31d2903f&scoped=true&"
import script from "./sitePermitsHomePageCard.vue?vue&type=script&lang=js&"
export * from "./sitePermitsHomePageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d2903f",
  null
  
)

export default component.exports